"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Warning = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = require("../Icon");
var styled_components_1 = __importDefault(require("styled-components"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 4px;\n    padding: 0 12px 0 13px;\n    background: ", ";\n    display: flex;\n"], ["\n    border-radius: 4px;\n    padding: 0 12px 0 13px;\n    background: ", ";\n    display: flex;\n"])), function (props) { return props.theme.BG_GREY; });
var IconWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-right: 15px;\n    padding: 8px 0;\n"], ["\n    margin-right: 15px;\n    padding: 8px 0;\n"])));
var ChildrenWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 7px 0 3px;\n"], ["\n    padding: 7px 0 3px;\n"])));
var Warning = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(Icon_1.Icon, { size: 16, icon: "WARNING_ACTIVE" })),
        react_1.default.createElement(ChildrenWrapper, null, children)));
};
exports.Warning = Warning;
var templateObject_1, templateObject_2, templateObject_3;
